/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import {
  Alert,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  IconButton,
  Link,
  Paper as MuiPaper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { green, orange, red } from "@mui/material/colors";
import { Add as AddIcon, Edit } from "@mui/icons-material";
import { spacing } from "@mui/system";
import { makeStyles, withStyles } from "@mui/styles";
import axios from "../../CustomAxios";
import { connect } from "react-redux";
import Loading from "../components/Loading";

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const useStyles = makeStyles({
  tableCell: {
    padding: "0px 12px 0px 0px",
    width: "1000px",
  },
});

const StyledTableContainer = withStyles((theme) => ({
  root: {
    // width: "max-content",
  },
}))(TableContainer);

const Chip = styled(MuiChip)`
  ${spacing};
  background: ${(props) => props.shipped && green[500]};
  background: ${(props) => props.processing && orange[700]};
  background: ${(props) => props.cancelled && red[500]};
  color: ${(props) => props.theme.palette.common.white};
`;

const Spacer = styled.div`
  flex: 1 1 100%;
`;

const ToolbarTitle = styled.div`
  min-width: 150px;
`;

function createData(id, name, description, is_deleted) {
  return {
    id,
    name,
    description,
    is_deleted,
  };
}

const headCells = [
  { id: "id", alignment: "left", label: "Sr No." },
  { id: "name", alignment: "left", label: "Name" },
  { id: "description", alignment: "left", label: "Description" },
];




const EnhancedTableHead = (props) => {
  const { edit } = props;
  const [heads, setHeads] = useState(headCells);
  useEffect(() => {
    if (edit) {
      setHeads((prev) => [
        ...prev,
        { id: "edit", alignment: "center", label: "Edit" },
      ]);
    }
  }, []);

  return (
    <TableHead>
      <TableRow>
        {heads.map((headCell) => (
          <TableCell
            // style={{ width: 100 }}
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? "none" : "normal"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const EnhancedTableToolbar = (props) => {
  // Here was 'let'
  const { numSelected } = props;
  const navigate = useNavigate();
  return (
    <Toolbar>
      <ToolbarTitle>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="h6" id="tableTitle">
            Brands
          </Typography>
        )}
      </ToolbarTitle>
      <Spacer />
      <Tooltip title="Create Technology">
        <IconButton size="large">
          <AddIcon
            onClick={() => navigate("/dashboard/inventory/technology")}
          />
        </IconButton>
      </Tooltip>
    </Toolbar>
  );
};

const getTechnology = async (authData, setLoader, setRows) => {
  try {
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${authData?.type}/plate_inventory/technology`,
      config
    );
    const brands = data.data;
    let rows = [];
    brands.map((brand) => {
      rows.push(
        createData(
          brand._id,
          brand.name,
          brand.description,
          brand?.is_deleted || false
        )
      );
    });
    setRows(rows);
    setLoader(false);
  } catch (e) {
    console.log(e);
  }
  setLoader(false);
};

function EnhancedTable({ rows, edit }) {
  const classes = useStyles();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("customer");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const navigate = useNavigate();
  const location = useLocation();
  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  useEffect(() => {
    if (location?.state?.success) {
      snackRef.current.click();
      navigate(location.pathname, { replace: true });
    }
  }, [location?.state]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <div>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        <Alert mt={2} mb={4} severity="success">
          Technology Created Successfully
        </Alert>
      </Snackbar>
      <Paper>
        <EnhancedTableToolbar numSelected={selected.length} />
        <StyledTableContainer>
          <Table size={"small"}>
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
              edit={edit}
            />
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={`${row.id}-${index}`}
                      selected={isItemSelected}
                    >
                      <TableCell align="left">
                        {page * rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell align="left">{row.name}</TableCell>
                      <TableCell align="left">{row.description}</TableCell>
                      {edit ? (
                        <TableCell align="center">
                          <Edit
                            style={{ cursor: "pointer", color: "red" }}
                            onClick={() =>
                              navigate(
                                `/dashboard/inventory/update-technology`,
                                {
                                  state: {
                                    id: row.id,
                                    name: row.name,
                                    description: row.description,
                                    is_deleted: row.is_deleted,
                                  },
                                }
                              )
                            }
                          />
                        </TableCell>
                      ) : null}
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={8} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </StyledTableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}

function ViewTechnology({ auths }) {
  const token = JSON.parse(localStorage.getItem("AuthData"));
  const [edit, setEditPermission] = useState(false);
  const [loader, setLoader] = useState(true);
  const [rows, setRows] = useState([]);
  useEffect(async () => {
    getTechnology(token, setLoader, setRows);
    if (
      auths?.user?.role?.permissions.includes("edit_technology") ||
      token?.type === "super_admin"
    ) {
      setEditPermission(true);
    }
  }, []);
  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              TECHNOLOGY
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Typography>View Technology</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <EnhancedTable edit={edit} rows={rows} />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}
const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(ViewTechnology);
